import React from 'react';
import { FaBoxOpen } from 'react-icons/fa';
import './EmptyState.css';

const EmptyState = ({ message = 'Nenhum item encontrado', icon: Icon = FaBoxOpen }) => {
  return (
    <div className="empty-state">
      <Icon className="empty-state-icon" />
      <p className="empty-state-message">{message}</p>
    </div>
  );
};

export default EmptyState;